import ReactECharts from 'echarts-for-react';
import dayjs from 'dayjs';
import { chartColors, chartGrid, chartText } from '../../lib/chartColors';
import AnnotatedTimeChart from './AnnotatedTimeChart';

export default function PriceTrendChart({series=[],height=390,showRange=true,metric='average_price',actual=false,fuel='BENZINA'}){
  const dates=series.map(x=>x.snapshot_date);
  const values=series.map(x=>Number(actual?x.price:x[metric]));
  const chartSeries=[];
  if(showRange&&!actual&&series.length){
    const p25=series.map(x=>Number(x.percentile_25));
    const band=series.map(x=>Number(x.percentile_75)-Number(x.percentile_25));
    chartSeries.push(
      {name:'25° percentile',type:'line',data:p25,stack:'quartile',symbol:'none',lineStyle:{opacity:0},areaStyle:{opacity:0},tooltip:{show:false}},
      {name:'Fascia 25°–75°',type:'line',data:band,stack:'quartile',symbol:'none',lineStyle:{opacity:0},areaStyle:{color:'#ffd9e2',opacity:1},tooltip:{show:false}}
    );
  }
  chartSeries.push({
    name:actual?'Prezzo impianto':metric==='median_price'?'Mediana':'Media',
    type:'line',
    data:values,
    smooth:false,
    symbol:'none',
    connectNulls:false,
    lineStyle:{width:4,color:chartColors[0],cap:'round',join:'round'},
    itemStyle:{color:chartColors[0]},
    emphasis:{focus:'series'}
  });
  if(!actual&&metric==='average_price') chartSeries.push({
    name:'Mediana',type:'line',data:series.map(x=>Number(x.median_price)),symbol:'none',
    lineStyle:{width:2,type:'dashed',color:chartColors[1]},itemStyle:{color:chartColors[1]}
  });
  const option={
    animationDuration:420,
    animationEasing:'cubicOut',
    grid:{left:54,right:14,top:48,bottom:42},
    legend:{top:4,left:4,textStyle:{fontFamily:'Rubik',fontSize:11,color:chartText,fontWeight:500},itemWidth:18,itemHeight:8},
    tooltip:{
      trigger:'axis',
      backgroundColor:'#fff8f9',
      borderWidth:0,
      padding:12,
      textStyle:{fontFamily:'Rubik',color:'#24191c'},
      extraCssText:'border-radius:18px;box-shadow:0 2px 8px rgba(35,25,27,.14);',
      axisPointer:{type:'line',lineStyle:{color:'#857278',width:1,type:'dashed'}},
      formatter:(params)=>{const i=params?.[0]?.dataIndex??0;const date=dates[i]?dayjs(dates[i]).format('DD/MM/YYYY'):'';const lines=params.filter(p=>p.seriesName!=='25° percentile'&&p.seriesName!=='Fascia 25°–75°').map(p=>`${p.marker} ${p.seriesName}: <b>${Number(p.value).toFixed(3)} €</b>`);return `<b>${date}</b><br>${lines.join('<br>')}`;}
    },
    xAxis:{type:'category',data:dates,boundaryGap:false,axisLabel:{hideOverlap:true,color:chartText,fontFamily:'Rubik',fontSize:10,formatter:v=>dayjs(v).format('DD/MM')},axisLine:{lineStyle:{color:chartGrid}},axisTick:{show:false}},
    yAxis:{type:'value',scale:true,axisLabel:{color:chartText,fontFamily:'Rubik',fontSize:10,formatter:v=>`${Number(v).toFixed(2)} €`},splitLine:{lineStyle:{color:chartGrid}},axisLine:{show:false},axisTick:{show:false}},
    dataZoom:[{type:'inside',filterMode:'none'}],
    series:chartSeries
  };
  if(fuel!=='BENZINA'&&fuel!=='GASOLIO') return <ReactECharts style={{height}} option={option}/>;
  return <AnnotatedTimeChart
    option={option}
    dates={dates}
    height={height}
    fuels={[fuel]}
    analysisSeries={[{name:actual?'Prezzo impianto':metric==='median_price'?'Mediana':'Media',values}]}
  />;
}
